import { z } from "zod";

export const EGlobalSearchCategory = {
  Transactions: "transactions",
  People: "people",
} as const;

export type TGlobalSearchCategory =
  (typeof EGlobalSearchCategory)[keyof typeof EGlobalSearchCategory];

export const globalSearchRequestSchema = z.object({
  companyID: z.string().min(1),
  q: z.string().min(1),
  category: z.enum(["transactions", "people"]).optional(),
  limit: z.coerce.number().int().min(1).max(20).optional().default(5),
});

export type TGlobalSearchRequest = z.infer<typeof globalSearchRequestSchema>;

export const globalSearchTransactionResultSchema = z.object({
  transactionID: z.string(),
  counterpartyName: z.string(),
  transactionType: z.string(),
  method: z.string().optional(),
  amount: z.number(),
  date: z.string().optional(),
  status: z.string().optional(),
});

export type TGlobalSearchTransactionResult = z.infer<
  typeof globalSearchTransactionResultSchema
>;

export const globalSearchPersonResultSchema = z.object({
  workerID: z.string(),
  fullName: z.string(),
  workerType: z.enum(["employee", "contractor"]),
  email: z.string().optional(),
});

export type TGlobalSearchPersonResult = z.infer<
  typeof globalSearchPersonResultSchema
>;

export const globalSearchResponseSchema = z.object({
  transactions: z.array(globalSearchTransactionResultSchema).optional(),
  people: z.array(globalSearchPersonResultSchema).optional(),
});

export type TGlobalSearchResponse = z.infer<typeof globalSearchResponseSchema>;
